import { useRecoilValue } from 'recoil';
import { Flags } from 'services/flags/constants';
import { useFlag } from 'services/flags/hooks';
import { organizationAtom } from 'services/organization/atom';
import { userAtom } from 'services/user/atoms';
import { userOrganizationAtom } from 'services/userOrganization/atom';
import { getIsHomeHidden } from 'modules/layout/utils/getIsHomeHidden';

export const useIsHomeHidden = () => {
  const isHomeTabHidden = Boolean(useFlag(Flags.HIDE_HOME_TAB));
  const user = useRecoilValue(userAtom);
  const userOrganization = useRecoilValue(userOrganizationAtom);
  const organization = useRecoilValue(organizationAtom);

  return getIsHomeHidden({
    isHomeTabHidden,
    user,
    userOrganization,
    organizationId: organization?.id
  });
};
